import { useMutation } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";
import { useAuth } from "./useAuth";
import { readStoredGlucoseLocale } from "../i18n/locale";

export function useCreateProfile() {
    const { user } = useAuth();

    return useMutation({
        mutationFn: async (phone: string) => {
            if (!user) {
                throw new Error("Not authenticated");
            }

            const { data, error } = await supabaseClient
                .from("profiles")
                .insert({
                    profile_id: user.id,
                    phone,
                    preferred_locale: readStoredGlucoseLocale(),
                })
                .select()
                .single();

            if (error) {
                throw error;
            }

            return data;
        },
    });
}
